import { Component } from '@angular/core';

@Component({
    selector: 'cart',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CartComponent {}
